export const EQUINE_REFERRED_INSURANCE_STATUS_ID = 'f6d14624-6351-4d93-b27b-70fb8a06ec5d';
export const EQUINE_QUOTED_INSURANCE_STATUS_ID = '80c0db90-ba5d-4387-b09a-4c008a664932';

const RESTRICTED_COVER_TYPE_ID = '2endc37f-b4a7-431e-9436-8d03cecceac0';

export function isEquineQuoteReferred(quote: any): boolean {
  if (!quote) return false;
  return quote.insurance_status_id === EQUINE_REFERRED_INSURANCE_STATUS_ID;
}

export function wasEquineQuotePreviouslyQuoted(quote: any): boolean {
  if (!quote) return false;
  return !!quote.was_previously_quoted
    || !!quote.quote_converted_date
    || quote.insurance_status_id === EQUINE_QUOTED_INSURANCE_STATUS_ID;
}

export function normalizeEquineQuotedReferralState(quote: any): any {
  if (!quote) return quote;
  const wasQuoted = wasEquineQuotePreviouslyQuoted(quote);
  const normalized = quote.insurance_status_id === EQUINE_QUOTED_INSURANCE_STATUS_ID
    ? { ...quote, is_manually_referred: 0 }
    : { ...quote };
  return wasQuoted ? { ...normalized, was_previously_quoted: true } : normalized;
}


export function isEquineRestrictedCoverSelected(quote: any, staticData?: any): boolean {
  const coverTypeId = quote?.cover_type_id ?? quote?.policy_cover_details?.cover_type_id;
  if (coverTypeId === '') return false;
  if (String(coverTypeId) === RESTRICTED_COVER_TYPE_ID) return true;
  const types = staticData?.cover_types;
  if (!Array.isArray(types)) return false;
  const match = types.find((t: any) => String(t?.id) === String(coverTypeId));
  const name = (match?.cover_type_name || '').toString().toLowerCase();
  return name.includes('restricted');
}

export function shouldShowEquinePremiumAsTbc(quote: any, staticData?: any): boolean {
  const si = Number(quote.sum_insured);
  //sum insured check
  if (si > 20000 && isEquineRestrictedCoverSelected(quote, staticData)) return true;
  if (si > 50000) return true;

  if (!isEquineQuoteReferred(quote)) return false;

  return false;
}
